









































import { Component, Prop, Vue } from "vue-property-decorator";

import ChangeDeliteButtons from "../buttons/change-delite-buttons.vue";

import { IDictionary } from "@/@types/dictionary";
import { deleteElement } from "@/api/delite/delite-element";
import { channels as tv } from "@/config/host.config";

@Component({ components: { ChangeDeliteButtons } })
export default class RecuclerDictionaryCard extends Vue {
  @Prop({ type: Object, default: null }) card!: IDictionary;

  show = this.card ? this.card.show : false;
  idOpen = "";

  logError(): void {
    this.$notify({
      group: "global",
      text: String(this.$i18n.t("error.empty400")),
      type: "warn",
    });
  }

  async deleteContentType(id: string): Promise<void> {
    if (!id) {
      this.logError();
      return;
    }

    try {
      const result = await this.$bvModal.msgBoxConfirm(
        String(this.$i18n.t("main.confirms.ok")),
        {
          title: String(this.$i18n.t("ChannelsPage.form.contentType.delete")),
        }
      );

      if (result === true) {
        const uri = tv.force_delete_content_type;
        deleteElement(id, uri)
          .then(() => {
            this.$emit("deleteContentType", id);
            this.$notify({
              group: "global",
              text: String(this.$i18n.t("error.200")),
            });
          })
          .catch(() => {
            this.logError();
          });
      }
    } catch {
      this.logError();
    }
  }

  async restoreCT(id: string | undefined): Promise<void> {
    if (!id) {
      this.logError();
      return;
    }
    const url = tv.content_type_restore + "/" + id;
    try {
      const restoreCT = await this.$axios.put(url);
      if (restoreCT.status === 200) {
        this.$notify({
          group: "global",
          text: String(this.$i18n.t("error.200")),
        });
        this.$emit("restoreCT", id);
      }
    } catch (error) {
      this.logError();
    }
  }
}
